import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { PLATFORM_ID, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { Capacitor } from '@capacitor/core';
import { Device } from '@capacitor/device';
import { I18NEXT_SERVICE } from 'angular-i18next';
import { Observable, from, map, of } from 'rxjs';
import { REQUEST, RESPONSE } from 'src/express.tokens';
import { routes } from 'utils/routes';

export const languageGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const router = inject(Router);
  const platformId = inject(PLATFORM_ID);
  const withDefault = (lang?: string) => {
    const fav = isPlatformBrowser(platformId) && localStorage.getItem('sharryFavouriteLanguage');
    return (lang || fav || 'it') as 'it';
  };
  const routeLanguage = withDefault(route.params['lang']);
  const translateService = inject(I18NEXT_SERVICE);
  if (!state.url || state.url === '/') {
    let language$: Observable<string>;
    if (isPlatformServer(platformId)) {
      const response = inject(RESPONSE);
      const request = inject(REQUEST);
      const reqLang = withDefault(request.i18n.language);
      language$ = of(reqLang);
      if (response) {
        response.redirect(301, '/' + reqLang);
      }
    } else {
      if (Capacitor.isNativePlatform()) {
        language$ = from(Device.getLanguageCode()).pipe(map(r => withDefault(r.value)));
      } else {
        language$ = of(translateService.language);
      }
    }

    return language$.pipe(
      map(language => router.parseUrl(`/${withDefault(language)}/${routes[withDefault(language)]['routes.explore']}`)),
    );
  } else if (['/it', '/en', '/es', '/fr', '/de'].includes(state.url)) {
    if (isPlatformServer(platformId)) {
      const response = inject(RESPONSE);
      if (response) {
        response.redirect(301, `/${routeLanguage}/${routes[routeLanguage]['routes.explore']}`);
      }
    }
    return router.parseUrl(`/${routeLanguage}/${routes[routeLanguage]['routes.explore']}`);
  } else if (['it', 'en', 'es', 'fr', 'de'].includes(routeLanguage)) {
    return true;
  } else {
    return router.parseUrl('/not-found');
  }
};
